import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ICadetformdata } from '../interfaces/cadetformdata';

@Injectable()
export class CadetapplicationpreviewService {
  private sharedCadetFormDataSource = new BehaviorSubject<ICadetformdata[]>(undefined);
  private getCadetConfNumberSource = new BehaviorSubject<any>(undefined);
  private getEditFlagValue = new BehaviorSubject<boolean>(undefined);

  sharedCadetFormData$ = this.sharedCadetFormDataSource.asObservable();
  getCadetConfNumber$ = this.getCadetConfNumberSource.asObservable();
  getEditFlagValue$ = this.getEditFlagValue.asObservable();
  constructor() { }

  passCadetFormData(previewCadetFormData: ICadetformdata[]) {
    this.sharedCadetFormDataSource.next(previewCadetFormData);
  }

  passCadetConfNumb(cadetConMsg) {
    this.getCadetConfNumberSource.next(cadetConMsg);
  }

  passEditFlag(EditFlagBack) {
    this.getEditFlagValue.next(EditFlagBack)
  }
}


// WEBPACK FOOTER //
// ./src/app/_services/cadetapplicationpreview.service.ts